<template>
  <el-drawer :title="$t('217')" :visible.sync="visible" :before-close="handleClose" size="500px">
    <div class="agree-preview">
      <div class="agree-container">
        <div class="agree-preview-body">
          <div class="agree-preview-body-content">
            <div class="preview-body w-e-text">
              <h3 class="center agree-title">{{ content.title }}</h3>
              <div v-dompurify-html="content.content" class="preview-body-body"></div>
              <div class="preview-body-active">
                <el-button type="primary" @click="handleClose">{{
                  $t('i18n.d6dfdb871b554f8f9a423c892fd33380')
                }}</el-button>
                <br />
                <el-button type="text" class="margin-top" @click="handleClose">{{
                  $t('i18n.a16f27870c274df3888c238abbfdd628')
                }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
// import preview from '@/components/mobile-preview'

export default {
  // components: { preview },
  props: {
    content: {
      type: Object,
      default: () => ({
        title: '',
        content: ''
      })
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  background: inherit;
  box-shadow: inherit;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    max-height: inherit;
    overflow: auto;
  }
}
.agree-container {
  height: 884px;
  width: 410px;
  margin: 0 auto;
  padding: 10px;
  border-radius: 37px;
  box-shadow: 0 0 20px rgba(213, 212, 212, 0.8);
  .agree-preview-body {
    background: url('~@/assets/img/phone.jpeg');
    border-radius: 30px;
    overflow: hidden;
    background-size: 100% 100%;
    height: 100%;
    width: 100%;
    // box-shadow: 0 0 8px rgba(52, 51, 51, 0.8);
    .agree-title {
      color: #000;
    }
    &-content {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      .preview-body {
        width: 85%;
        height: 50%;
        background: #ffffff;
        border: 1px solid #cccccc;
        border-radius: 20px;
        padding: 24px 24px 16px 24px;
        position: relative;
        padding-bottom: 90px;
        &-active {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 90px;
          text-align: center;
        }
        &-body {
          height: 253px;
          overflow: auto;
          &::-webkit-scrollbar {
            width: 0 !important;
          }
        }
      }
    }
  }
}
</style>
